import axios from "axios";

const connection = process.env.REACT_APP_AUTH_CONNECTION
const connectionId = process.env.REACT_APP_AUTH_CONNECTION_ID

export default function impersonateLogin({
  token,
}) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/authentication/api/basic/impersonate-signin`,
        {
          connection,
          connection_id: connectionId,
          token,
        }
      )
      .then((response) => resolve(response))
      .catch((error) => reject(error.response.data));
  });
}
